﻿const none = [];
const defaultToolbar = [
    'sourceEditing', '|',
    'undo', 'redo', 'formatPainter', 'removeFormat', '|',
    'link', 'insertTable', 'horizontalLine', 'specialCharacters', '|',
    'fontColor', 'fontBackgroundColor', 'fontFamily', 'fontSize', 'lineHeight', '|',
    'bold', 'italic', 'underline', 'strikethrough', '|',
    'alignment', '|',
    'subscript', 'superscript', '|',
    'numberedList', 'bulletedList',
];
const defaultToolbarWithStyle = [
    ...defaultToolbar,
    '|', 'style', 'heading',
];

const toolbars = {
    'None': none,
    'Default': defaultToolbar,
    'DefaultWithStyle': defaultToolbarWithStyle,
}

function setToolbarByName(config) {
    if (config && config.toolbarName) {
        config.toolbar = config.toolbar || {};
        config.toolbar.items = structuredClone(toolbars[config.toolbarName]);
    }
}

function addToolbar(name, items) {
    toolbars[name] = items;
}

export default toolbars;
export { setToolbarByName, addToolbar };